import React, { useEffect, useState } from "react";
import BaseModalAnimated from "./BaseModalAnimated";

const PreviewPDF = ({ modal, setModal }) => {
    const [fileURL, setFileURL] = useState(null);

    useEffect(() => {
        if (modal.url) {
            // Lógica de fetch simplificada para el ejemplo
            setFileURL(modal.url);
        }
    }, [modal.url]);

    const close = () => setModal({ ...modal, show: false });
    const isImage = typeof fileURL === 'string' && fileURL.startsWith('data:image/');

    return (
        <BaseModalAnimated setModal={setModal} modal={modal}>
            <div className="relative w-full h-[85vh] sm:h-[80vh] bg-cs-dark flex flex-col">

                {/* Header Estilo Apple */}
                <div className="flex items-center justify-between px-5 py-4 bg-cs-dark/80 backdrop-blur-md border-b border-white/10">
                    <div>
                        <p className="text-[10px] uppercase tracking-widest text-cs-primary font-bold">Vista Previa</p>
                        <h2 className="text-white text-sm font-medium truncate max-w-[200px]">
                            {modal.title || "Documento"}
                        </h2>
                    </div>
                    <button
                        onClick={close}
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-cs-danger transition-colors"
                    >
                        <span className="text-xl leading-none">×</span>
                    </button>
                </div>

                {/* Visor de PDF */}
                <div className="flex-1 bg-neutral-800 relative">
                    {fileURL ? (
                        isImage ? (
                            <div className="w-full h-full flex items-center justify-center p-4">
                                <img src={fileURL} alt="Document preview" className="max-w-full max-h-full object-contain rounded-lg" />
                            </div>
                        ) : (
                            <iframe
                                src={`${fileURL}#toolbar=0`} // Oculta barra de herramientas nativa si es posible
                                className="w-full h-full border-none"
                                title="pdf-preview"
                            />
                        )
                    ) : (
                        <div className="absolute inset-0 flex flex-col items-center justify-center">
                            <div className="w-8 h-8 border-2 border-cs-primary border-t-transparent animate-spin rounded-full mb-4" />
                            <p className="text-white/50 text-xs">Cargando documento...</p>
                        </div>
                    )}
                </div>

                {/* Footer Flotante / Action Bar */}
                <div className="p-1 bg-cs-dark/90 border-t border-white/5 pb-safe">
                    <button
                        onClick={close}
                        className="w-full py-3.5 bg-cs-primary hover:bg-cs-primary-hover text-white font-semibold rounded-xl transition-all active:scale-[0.98] shadow-lg"
                    >
                        Entendido
                    </button>
                </div>
            </div>
        </BaseModalAnimated>
    );
};

export default PreviewPDF;